import { LoaderCircle } from "lucide-react";
import "./LoadingSpinner.scss";

export default function LoadingSpinner({
  size,
  fullPage = false,
  className = "",
  style = {},
}: {
  size?: number;
  fullPage?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) {
  if (!size) {
    size = fullPage ? 128 : 24;
  }
  return (
    <div
      className={
        fullPage ? "loading-div loading-div-full-page" : "loading-div c-flex"
      }
    >
      <LoaderCircle className={`spinning ${className}`} style={style} size={size} />
    </div>
  );
}
